import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IConversation } from 'models/IConversation';

interface IReferencedConversationsState {
    conversations: IConversation[];
};

const initialState: IReferencedConversationsState = {
    conversations: []
};

export const referencedConversationsSlice = createSlice({
    name: 'referencedConversations',
    initialState,
    reducers: {
        setReferencedConversations: (state, action: PayloadAction<IConversation[]>) => {
            state.conversations = action.payload;
        },
        clearReferencedConversations: (state) => {
            state.conversations = [];
        }
    }
});

export const { setReferencedConversations, clearReferencedConversations } = referencedConversationsSlice.actions;

export default referencedConversationsSlice.reducer;